import Vue from "vue";
import VueApollo from "vue-apollo";
import {
    createApolloClient
} from "vue-cli-plugin-apollo/graphql-client";
import {InMemoryCache} from 'apollo-cache-inmemory'
// import {persistCache} from 'apollo-cache-persist'

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint =
    // process.env.VUE_APP_GRAPHQL_HTTP || "/graphql";
    process.env.VUE_APP_GRAPHQL_HTTP || "/career/graphql";
// Files URL root
export const filesRoot =
    process.env.VUE_APP_FILES_ROOT ||
    httpEndpoint.substr(0, httpEndpoint.indexOf("/graphql"));
// Configure cache
const cache = new InMemoryCache();
// if (process.browser) {
//     persistCache({
//         cache,
//         storage: window.localStorage
//     })
// }

Vue.prototype.$filesRoot = filesRoot;

// Config
const defaultOptions = {
    // You can use `https` for secure connection (recommended in production)
    httpEndpoint,

    // Override default cache
    cache,

    persisting: false

    // Override the way the Authorization header is set
    // getAuth: (tokenName) => ...

    // Additional ApolloClient options
    // apollo: { ... }

    // Client local data (see apollo-link-state)
    // clientState: { resolvers: { ... }, defaults: { ... } }
};

// Call this in the Vue app file
export function createProvider(options = {}) {
    // Create apollo client
    const {apolloClient} = createApolloClient({
        ...defaultOptions,
        ...options
    });

    // Create vue apollo provider
    return new VueApollo({
        defaultClient: apolloClient,
        defaultOptions: {
            $query: {
                // fetchPolicy: 'cache-and-network',
            }
        },
        errorHandler(error) {
            // eslint-disable-next-line no-console
            console.log(
                "%cError",
                "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
                error.message
            );
        }
    });
}

